import Vue from "vue";
import app from "@/main";
export const closeToast = (id?: string) => {
  if (id) {
    Vue.$btoast.dismiss(id);
  } else {
    Vue.$btoast.clear();
  }
};
export const useToast = (text: string, toastOption?: Record<string, any>) => {
  const id = Vue.$btoast(text, {
    duration: toastOption?.duration || 5000,
    type: toastOption?.type || "success",
    isDark: app.$vuetify.theme.dark,
  });
  return id;
};
